import React, {useState} from "react";
import { Link } from "react-router-dom";
import { sendPasswordResetEmail } from "../../services/Api";
import { useToast } from '../../services/ToastContext';

const ForgotPasswordPage = () => {
  const { showToast } = useToast();
  const [email,setEmail] = useState("");
  const handleResetPassword = async (e) => {
    e.preventDefault();
    await sendPasswordResetEmail(email);
    setEmail("");
    showToast("If you have an account, a reset password email has been sent!")
  };

  return (
    <>
      <div className="container">
        {/* Outer Row */}
        <div className="row justify-content-center">
          <div className="col-xl-10 col-lg-12 col-md-9">
            <div className="card o-hidden border-0 shadow-lg my-5">
              <div className="card-body p-0">
                {/* Nested Row within Card Body */}
                <div className="row">
                  <div className="col-lg-2 d-none d-lg-block bg-password-image" />
                  <div className="col-lg-8">
                    <div className="p-5">
                      <div className="text-center">
                        <h1 className="h4 text-gray-900 mb-2">
                          Forgot Your Password?
                        </h1>
                        <p className="mb-4">
                          We get it, stuff happens. Just enter your email
                          address below and we'll send you a link to reset your
                          password!
                        </p>
                      </div>
                      <form className="user">
                        <div className="form-group">
                          <input
                            type="email"
                            className="form-control form-control-user"
                            id="exampleInputEmail"
                            aria-describedby="emailHelp"
                            placeholder="Enter Email Address..."
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                          />
                        </div>
                        <button
                          href="login.html"
                          className="btn btn-primary btn-user btn-block"
                          onClick={handleResetPassword}
                        >
                          Reset Password
                        </button>
                      </form>
                      <hr />
                      <div className="text-center">
                        <Link to="/create-account" className="small">
                          Create Account
                        </Link>
                      </div>
                      <div className="text-center">
                        <Link to="/login" className="small">
                          Login
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPasswordPage;
